  $('.slider-show').slick({
       autoplaySpeed:2000,
       speed:3000,
       autoplay:true,
      lazyLoad: 'ondemand',
       slidesToShow:2,
       slideToscroll:1,
       arrows:false,
       dots:true,
       centerMode: true, //要素を中央寄せ
       centerPadding: '10%',//左右の画像が見える幅
    responsive: [
    {
      breakpoint: 769,//モニターの横幅が769px以下の見せ方
      settings: {
        slidesToShow: 1,//スライドを画面に2枚見せる
      },
    },
    {
      breakpoint: 426,//モニターの横幅が426px以下の見せ方
      settings: {
        slidesToShow: 1,//スライドを画面に1.5枚見せる
      },
    },
    ],
});